var loyalty = "https://shopfront-cdn.tekoapis.com/static/fedbd47700ec8fe6.svg";

export { loyalty as default };
